var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 6C40 2.7 37.3 0 34 0H6C2.7 0 0 2.7 0 6V34C0 37.3 2.7 40 6 40H34C37.3 40 40 37.3 40 34V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 6C40 2.7 37.3 0 34 0H6C2.7 0 0 2.7 0 6V34C0 37.3 2.7 40 6 40H34C37.3 40 40 37.3 40 34V6Z",
    fill: "currentColor",
    fillOpacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15V33.9999L26.4 32.0909L24.8 33.9999L23.2 32.0909L21.6 33.9999L20 32.0909L18.4 33.9999L16.8 32.0909L15.2 33.9999L13.6 32.0909L12 33.9999V15H28Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4231 21.25H17.5769C17.2583 21.25 17 20.9702 17 20.625C17 20.2798 17.2583 20 17.5769 20H22.4231C22.7417 20 23 20.2798 23 20.625C23 20.9702 22.7417 21.25 22.4231 21.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4565 24.25H15.5435C15.2433 24.25 15 23.9702 15 23.625C15 23.2798 15.2433 23 15.5435 23H24.4565C24.7567 23 25 23.2798 25 23.625C25 23.9702 24.7567 24.25 24.4565 24.25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4565 27.25H15.5435C15.2433 27.25 15 26.9702 15 26.625C15 26.2798 15.2433 26 15.5435 26H24.4565C24.7567 26 25 26.2798 25 26.625C25 26.9702 24.7567 27.25 24.4565 27.25Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10V15H29V13.539H11V15H8V10H32Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReceipt);
export default __webpack_public_path__ + "static/media/ic_receipt.ee1c6cf1e6107e252b594683ffb3db3a.svg";
export { ForwardRef as ReactComponent };